/* loaded by smart-asset */
export default require("./1~BqIUbvMv.svg")